/**
 * @Description: 系统预置标签模板信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  TemplatePresetModel,
  TemplatePresetSearchModel,
  TemplatePresetPageSearchModel,
  TemplatePresetAddModel,
  TemplatePresetUpdateModel,
  TemplatePresetViewModel,
  IdsModel
} from '@/model/product/TemplatePresetModel'

const baseUrl = Route.product + '/templatePreset'

/**
 * 搜索分页数据
 */
export const pageSearchTemplatePreset = (param: TemplatePresetPageSearchModel) => {
  return https().request<RootObject<PageRespModel<TemplatePresetViewModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchTemplatePreset = (param: TemplatePresetSearchModel) => {
  return https().request<RootObject<TemplatePresetModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getTemplatePreset = (id: number) => {
  return https().request<RootObject<TemplatePresetModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addTemplatePreset = (param: TemplatePresetAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateTemplatePreset = (param: TemplatePresetUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeTemplatePreset = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveTemplatePreset = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
